import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SalesTransportCapacityRoutingModule } from './sales-transport-capacity-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { SalesTransportCapacityComponent } from './sales-transport-capacity.component';

@NgModule({
  declarations: [
    SalesTransportCapacityComponent
  ],
  imports: [
    CommonModule,
    SalesTransportCapacityRoutingModule,
    SharedModule
  ]
})
export class SalesTransportCapacityModule { }
